import qs from "qs"
import endpoints from "@irati/payments/endpoints"
import {getDomain} from "@irati/utils/links"
import authentication from "@irati/auth"
import {Deal, Checkout} from "@irati/types"

export function getAdyenCallbackUrlForRedirect(deal: Deal, checkout: Checkout) {
  const domain = getDomain(authentication.userTenant().subdomain)
  const query = qs.stringify({
    redirectTo: `${domain}/perks/info/${deal.urlSlug}/payment-redirect/${checkout.uuid}`
  })
  return `${endpoints.adyenRedirectCallbackUrl()}?${query}`
}
